const NODE = process.env.NODE_ENV;

// 登录
export const login_url = NODE === 'development' ? '开发' : '正式';
// 其他
export const shop_url = NODE === 'development' ? 'http://10.0.1.33:8769' : 'https://api.rangepark.cn';
// export const shop_url = NODE === 'development' ? 'http://123.58.251.211' : 'https://api.rangepark.cn';


// WEBPACK FOOTER //
// ./src/global/index.js